<template>
    <div class="field" :class="[ { 'no-placeholder': !label } ]">
        <div class="input-group">
            <input
                :type="inputType"
                :name="name"
                :placeholder="placeholder"
                class="input"
                :value="maskedValue"
                :required="isRequired"
                :disabled="disabled"
                @input="handleInput"
                @change="handleChange"
                @focus="handleFocus"
                @blur="handleBlur"
                v-bind="maxlength > 0 ? { maxlength } : {}"
            />
            <span>{{ label }}</span>
            <i
                v-if="type === 'password'"
                @click="togglePasswordVisibility"
                class="bi"
                :class="showPassword ? 'bi-eye' : 'bi-eye-slash'"
                title="Mostrar Senha"
            ></i>
            <span class="icons"></span>
        </div>
        <strong class="tip" v-if="tip">{{ tip }}</strong>
        <div class="errors" v-if="error">
            <div v-if="Array.isArray(error)" v-for="(err, index) in error" :key="index">{{ err }}</div>
            <div v-else>{{ error }}</div>
        </div>
    </div>
</template>

<script>
import * as maskUtils from "@/store/mask.js";

export default {
    name: "InputField",
    props: {
        type: {
            type: String,
            default: "text"
        },
        name: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        value: {
            type: String,
            default: ""
        },
        required: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        maskType: {
            type: String,
            default: ""
        },
        maxlength: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    },
    emits: [
        "value-updated",
        "event:blur",
        "event:focus",
        "event:input"
    ],
    data() {
        return {
            showPassword: false,
            rawValue: this.value
        };
    },    
    computed: {
        inputType() {
            return this.showPassword ? "text" : this.type;
        },
        isRequired() {
            return this.required==='required'?this.required:false;
        },
        maskedValue() {
            if (this.maskType && typeof maskUtils[`format${this.maskType.charAt(0).toUpperCase() + this.maskType.slice(1)}`] === "function") {
                return maskUtils[`format${this.maskType.charAt(0).toUpperCase() + this.maskType.slice(1)}`](this.rawValue);
            }
            return this.rawValue;
        }
    },
    watch: {
        value(newValue) {
            this.rawValue = newValue;
        },
        rawValue(newValue) {
            this.$emit("value-updated", { key: this.name, value: newValue, type: this.type });
        }
    },
    methods: {
        handleInput(event) {
            if (this.type === "file") {
                // Ignorar manipulação para inputs do tipo file
                return;
            }
            this.rawValue = event.target.value;
            event.target.value = this.maskedValue;
            return false;
        },
        handleChange(event) {
            if (this.type === "file") {
                const files = event.target.files;
                this.$emit("value-updated", files);
            }
        },
        handleBlur() {
            this.$emit('event:blur');
        },
        handleFocus() {
            this.$emit('event:focus');
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
    },
};
</script>
